'use client'
import dynamic from 'next/dynamic'

import { RaButton, RaButtonProps } from '@components/core/index.core'
import { useUi } from '@contexts/ui.context'
import { AcfForm, GravityFormsApiProps } from '@typings'

import { useSettings } from '@/contexts/settings.context'
import { useDestinationSlug } from '@/hooks/useDestinationSlug'
import { GA4Events } from '@/utilities/ga4-helpers/GA4Events.helpers'

const RaFormWrapper = dynamic(() =>
  import('@components/form-elements/RaFormWrapper/RaFormWrapper').then(
    ({ RaFormWrapper }) => RaFormWrapper,
  ),
)

const RaTravelplanForm = dynamic(() =>
  import('@components/features/RaTravelplanForm/RaTravelplanForm').then(
    ({ RaTravelplanForm }) => RaTravelplanForm,
  ),
)

interface RaFormDialogButtonProps {
  form: AcfForm
  label: string
  modalTitle?: string
  fullscreen?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forwardProps?: any
  isTravelplan?: boolean
  variant?: RaButtonProps['variant']
  formData?: GravityFormsApiProps
  destination?: string
}

export const RaFormDialogButton = ({
  form,
  label,
  modalTitle,
  fullscreen = true,
  forwardProps,
  isTravelplan = false,
  variant,
  formData,
  destination: destinationProp,
}: RaFormDialogButtonProps) => {
  const { GTM_ID, isFamilySite } = useSettings()
  const contextDestination = useDestinationSlug()
  const destination = destinationProp || contextDestination
  const analytics = new GA4Events({
    mode: 'client',
    gtmId: GTM_ID,
    destination,
    isFamilySite,
  })

  const ui = useUi()
  const openFormDialog = () => {
    if (!ui) {
      console.warn('Modal context is not defined')
    }

    if (isTravelplan) {
      ui.showModal({
        content: (
          <RaTravelplanForm
            form={form}
            formData={formData}
            title={forwardProps.title}
            image={forwardProps.image}
          />
        ),
        fullscreen,
        bgColor: 'var(--color-bg-light)',
        isTravelplan: true,
        customCloseButton: forwardProps.close,
      })
    } else {
      ui.showModal({
        title: modalTitle ? modalTitle : label,
        content: (
          <RaFormWrapper
            {...form}
            formData={formData}
            destination={destination}
          />
        ),
        fullscreen,
      })
      analytics.openEnquiryModal({
        title: modalTitle || label,
        country: destination,
      })
    }
  }
  return (
    <RaButton
      type="button"
      label={label}
      onClick={openFormDialog}
      variant={variant}
    />
  )
}
